import { Controller } from 'stimulus';
import { Turbo } from '@hotwired/turbo-rails';
import DfApi from '@/js/modules/df_api';

export default class extends Controller {
  #api = new DfApi();
  #requesting = false;
  #queuedSelection = null;

  // The server saves whatever selection each request carries, so requests run one at a time
  // in selection order. Selections made meanwhile collapse into the latest one.
  async select(event) {
    this.#queuedSelection = {
      ...this.#getResourceIds(event),
      clientIds: event.detail.clients ? event.detail.clients.map((c) => c.id) : event.detail.values,
    };
    if (this.#requesting) {
      return;
    }

    this.#requesting = true;
    try {
      while (this.#queuedSelection) {
        const { projectId, contractId, clientIds } = this.#queuedSelection;
        this.#queuedSelection = null;

        try {
          const response = await this.#api.buildClientSignatures(projectId, contractId, clientIds);
          const html = await response.text();

          if (!this.#queuedSelection) {
            Turbo.renderStreamMessage(html);
          }
        } catch (error) {
          // A queued selection supersedes the failed one, so carry on and save it instead.
          if (!this.#queuedSelection) {
            throw error;
          }
        }
      }
    } finally {
      this.#requesting = false;
    }
  }

  #getResourceIds(event) {
    const form = event.target.closest('form');
    const regex = /\/projects\/(\d+)\/contracts\/(\d+)/;
    const match = form.action.match(regex);

    return { projectId: match[1], contractId: match[2] };
  }
}
